/**
 * View component for /admin/authoring/sponsors/:sponsorId
 *
 * Displays a single sponsor from the 'byId' map in the sponsor reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sponsorActions from '../sponsorActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import SponsorLayout from '../components/SponsorLayout.js.jsx';

// import sponsor components

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

class SingleSponsor extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.fetchSingleIfNeeded(match.params.sponsorId));
  }

  render() {
    const { history, sponsorStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual sponsor object from the map
     */
    const selectedSponsor = sponsorStore.selected.getItem();

    const isEmpty = (
      !selectedSponsor
      || !selectedSponsor._id
      || sponsorStore.selected.didInvalidate
    );

    return (
      <SponsorLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              { isEmpty ?
                  (sponsorStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                  <div style={{ opacity: sponsorStore.isFetching ? 0.5 : 1 }}>
                    <div className="yt-row space-between" style={{paddingTop:"10px",paddingBottom:"10px"}}>
                      <a onClick={() => history.goBack()}><i className="fa fa-arrow-left" /> Back</a>
                    </div>
                    <h1> { selectedSponsor.name } </h1>
                    <hr/>
                    <img src={selectedSponsor.logo ? selectedSponsor.logo : "/img/yt_logo.png"} />
                  </div>
              }
            </div>
          </section>
        </div>
      </SponsorLayout>
    )
  }
}

SingleSponsor.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sponsorStore: store.sponsor
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleSponsor)
);



// WEBPACK FOOTER //
// modules/sponsor/views/SingleSponsor.js.jsx